export function hasVerifiedBuildCompletionEvidence(input) {
    return hasVerifiedTerminalCompletion(input) || hasVerifiedPhaseSevenProgress(input);
}
/**
 * Checks whether a terminal completion can close the current build snapshot.
 *
 * Args:
 *   input: Completion evidence collected from canonical events and progress files.
 *
 * Returns:
 *   True when the terminal belongs to the active build or is not older than known fresh work.
 *
 * Raises:
 *   None.
 */
function hasVerifiedTerminalCompletion(input) {
    const terminal = input.terminal ?? null;
    if (!terminal || terminal.terminalStatus !== 'completed')
        return false;
    if (input.gameId && terminal.gameId && terminal.gameId !== input.gameId)
        return false;
    const expectedBuildRunId = input.currentBuildRunId ?? input.progress?.buildSessionId;
    if (terminal.buildRunId && expectedBuildRunId && terminal.buildRunId !== expectedBuildRunId) {
        return false;
    }
    const terminalAt = parseIsoMs(terminal.occurredAt);
    const freshnessCutoffAt = parseIsoMs(input.freshnessCutoffAt);
    if (terminal.buildRunId &&
        !expectedBuildRunId &&
        freshnessCutoffAt !== null &&
        (terminalAt === null || terminalAt < freshnessCutoffAt)) {
        // A newer interview marker means this terminal is from a previous run until proven otherwise.
        return false;
    }
    return !hasNewerDifferentActiveEvidence(input.activeEvidence, terminal);
}
function hasVerifiedPhaseSevenProgress(input) {
    const progress = input.progress ?? null;
    if (!progress || (progress.currentPhase ?? 0) < 7)
        return false;
    if (progress.buildSessionId &&
        input.currentBuildRunId &&
        progress.buildSessionId !== input.currentBuildRunId) {
        return false;
    }
    if (progress.buildSessionId)
        return true;
    if (!progress.lastTransitionAt || !input.freshnessCutoffAt)
        return false;
    return Date.parse(progress.lastTransitionAt) > Date.parse(input.freshnessCutoffAt);
}
function hasNewerDifferentActiveEvidence(activeEvidence, terminal) {
    if (!terminal.buildRunId)
        return false;
    const terminalAt = parseIsoMs(terminal.occurredAt);
    return (activeEvidence ?? []).some((entry) => {
        if (!entry.buildRunId || entry.buildRunId === terminal.buildRunId)
            return false;
        const observedAt = parseIsoMs(entry.observedAt);
        if (terminalAt === null || observedAt === null)
            return true;
        return observedAt > terminalAt;
    });
}
function parseIsoMs(value) {
    if (!value)
        return null;
    const parsed = Date.parse(value);
    return Number.isFinite(parsed) ? parsed : null;
}
//# sourceMappingURL=build-completion-evidence.js.map